import { CameraControls } from '@react-three/drei';
import { useThree } from '@react-three/fiber';
import { useState } from 'react';
import tunnel from 'tunnel-rat';

import CameraButtons from '@cartwhl/ui/molecules/CameraButtons';

export const VerificationCameraButtonsSlot = tunnel();

export default function VerificationCameraButtons() {
  const [inputMode, setInputMode] = useState<'rotate' | 'truck' | 'dolly'>(
    'rotate',
  );

  const { controls } = useThree();
  const cameraControls = controls as unknown as CameraControls;

  return (
    <VerificationCameraButtonsSlot.In>
      <div className="absolute bottom-0 left-4 top-0 hidden items-center sm:flex md:left-0">
        <CameraButtons.Root tooltipSide="right" inModal>
          <CameraButtons.InputMode
            inputMode={inputMode}
            setCameraInputMode={(mode: 'rotate' | 'truck' | 'dolly') => {
              if (!cameraControls) return;
              setInputMode(mode);
              if (mode === 'truck') {
                cameraControls.mouseButtons.left = 2;
                cameraControls.mouseButtons.right = 1;
                cameraControls.mouseButtons.middle = 8;
              } else if (mode === 'rotate') {
                cameraControls.mouseButtons.left = 1;
                cameraControls.mouseButtons.right = 2;
                cameraControls.mouseButtons.middle = 8;
              } else {
                cameraControls.mouseButtons.left = 8;
                cameraControls.mouseButtons.right = 2;
                cameraControls.mouseButtons.middle = 1;
              }
            }}
          />
          <CameraButtons.Zoom
            zoomIn={() => cameraControls?.dolly(1, true)}
            zoomOut={() => cameraControls?.dolly(-1, true)}
          />
          <CameraButtons.Reset
            resetCamera={() => cameraControls?.reset(true)}
            disableCameraReset={false} // TODO
          />
        </CameraButtons.Root>
      </div>
    </VerificationCameraButtonsSlot.In>
  );
}
